import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Authentication";

export const SIGN_IN_ENDPOINT = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AdminLogin`, options);

export const SIGN_IN_USER_ENDPOINT = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Login`, options);

const forgetPassword = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ForgetPassword`, options);

const resetPassword = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ResetPassword`, options);

export default {
  SIGN_IN_ENDPOINT,
  SIGN_IN_USER_ENDPOINT,
  forgetPassword,
  resetPassword,
};
